import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Trophy, AlertCircle, Send } from 'lucide-react';

export default function Submit() {
  const { t } = useTranslation();
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [_loading, _setLoading] = useState(false);

  const titleOk = title.length >= 8 && title.length <= 140;
  const descOk = description.length <= 1000;

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!titleOk || !descOk) return;
    // TODO: POST to /api/checkout/submit, redirect to Stripe Checkout, then on
    // return POST to /api/quests with the session_id.
    alert('Stripe Checkout integration: prossimo step (gli endpoint sono pronti)');
  }

  return (
    <section className="section">
      <div className="container-narrow max-w-3xl">
        <div className="text-center mb-12">
          <h1 className="font-pixel text-5xl sm:text-6xl font-bold tracking-tight">
            {t('submit.title')}
          </h1>
          <p className="mt-4 text-kquest-300 text-lg">
            {t('submit.subtitle')}
          </p>
        </div>

        <form onSubmit={handleSubmit} className="kblock p-8 space-y-6">
          <div>
            <label className="block font-pixel text-sm uppercase tracking-wider text-kquest-200 mb-2">
              {t('submit.title_label')}
            </label>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              maxLength={140}
              placeholder={t('submit.title_placeholder')}
              className="w-full bg-kquest-900 border-2 border-kquest-700 focus:border-kquest-400 px-4 py-3 text-kquest-100 placeholder-kquest-500 outline-none font-pixel"
            />
            <div className={`mt-1 text-xs font-pixel ${titleOk ? 'text-xp-400' : 'text-kquest-400'}`}>
              {title.length} / 140 — {titleOk ? '✓ ok' : 'min 8 caratteri'}
            </div>
          </div>

          <div>
            <label className="block font-pixel text-sm uppercase tracking-wider text-kquest-200 mb-2">
              {t('submit.desc_label')}
            </label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              maxLength={1000}
              rows={5}
              placeholder={t('submit.desc_placeholder')}
              className="w-full bg-kquest-900 border-2 border-kquest-700 focus:border-kquest-400 px-4 py-3 text-kquest-100 placeholder-kquest-500 outline-none font-pixel resize-none"
            />
            <div className="mt-1 text-xs font-pixel text-kquest-400">
              {description.length} / 1000
            </div>
          </div>

          <div className="block-purple p-4">
            <div className="flex items-start gap-3">
              <AlertCircle className="w-5 h-5 text-gold-400 flex-shrink-0 mt-0.5" />
              <div className="text-sm text-kquest-200">
                <strong className="font-pixel text-gold-300">{t('submit.warn_title')}</strong>
                <p className="mt-1 leading-relaxed">{t('submit.warn_desc')}</p>
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-center gap-4 justify-between pt-4 border-t-2 border-kquest-700">
            <div className="text-sm text-kquest-300 font-pixel">
              <span className="text-gold-400 font-press text-xl">€5</span> {t('submit.price_note')}
            </div>
            <button
              type="submit"
              disabled={!titleOk || !descOk}
              className="btn-gold !px-8 !py-3 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <Trophy className="w-5 h-5" />
              {t('submit.cta')}
              <Send className="w-4 h-4" />
            </button>
          </div>
        </form>

        <p className="mt-8 text-center text-xs text-kquest-400 font-pixel">
          {t('submit.fine_print')}
        </p>
      </div>
    </section>
  );
}
